// extracted by css-extract-rspack-plugin
export default {"cls1":"dossier-cls1_bFK","cls2":"dossier-cls2_MWu dossier-cls1_bFK"};